import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import ImageWithBasePath from "../core/img/imagewithbasebath";
import { login as authLogin } from '../services/authService';
import Navbar from "../components/landingpage/sections/Navbar";

const LoginCelebrity = (props) => {
    const navigate = useNavigate();
    const [credentials, setCredentials] = useState({
        userPhone: '',
        userPassword: ''
    });
    const [isPasswordVisible, setIsPasswordVisible] = useState(false);
    const [error, setError] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        document.body.classList.add("account-page");
        return () => document.body.classList.remove("account-page");
    }, []);

    // Special handler for phone input
    const handlePhoneChange = (phoneValue) => {
        setCredentials({
            ...credentials,
            userPhone: phoneValue
        });
    };

    const handleChange = (e) => {
        setCredentials({
            ...credentials,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setError(null);

        try {
            const response = await authLogin(credentials);
            console.log('CELEB LOGIN RESPONSE:', response);

            if (response.success) {
                // Navigate to OTP verification instead of direct login
                navigate('/celeb-email-otp-verify', {
                    state: {
                        userPhone: credentials.userPhone,
                        userPassword: credentials.userPassword,
                        userEmail: response.data.userEmail
                    }
                });
            }
        } catch (err) {
            setError(err.message || 'Login failed. Please try again.');
        } finally {
            setIsLoading(false);
        }
    };

    const handleEmailLogin = () => {
        navigate('/celeb-email-login');
    };

    return (
        <>
            <Navbar {...props} />
            <div className="content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-8 offset-md-2">
                            <div className="account-content">
                                <div className="row align-items-center justify-content-center">
                                    <div className="col-md-7 col-lg-6 login-left">
                                        <ImageWithBasePath
                                            src="assets/img/Artboard7.svg"
                                            className="img-fluid"
                                            alt="Howzit! Login"
                                        />
                                    </div>
                                    <div className="col-md-12 col-lg-6 login-right">
                                        <div className="login-header">
                                            <div className="d-flex justify-content-between align-items-center mb-2">
                                                <h3 className="mb-0">
                                                    Login <span>howzit! Dashboard</span>
                                                </h3>
                                                <Link
                                                    to="/"
                                                    className="btn btn-outline-secondary btn-sm"
                                                    style={{
                                                        fontSize: '14px',
                                                        padding: '4px 12px'
                                                    }}
                                                >
                                                    <i className="fas fa-home me-1"></i>
                                                    Home
                                                </Link>
                                            </div>
                                        </div>
                                        {error && (
                                            <div className="alert alert-danger mb-4">
                                                <div className="d-flex align-items-center">
                                                    <i className="fas fa-exclamation-triangle me-2"></i>
                                                    <div>
                                                        <strong>Login Error!</strong>
                                                        <div className="small">{error}</div>
                                                        {error.includes('fan') && (
                                                            <button
                                                                className="btn btn-link p-0 alert-link"
                                                                onClick={() => {
                                                                    sessionStorage.setItem('showLoginModal', 'true');
                                                                    navigate('/');
                                                                }}
                                                            >
                                                                Go to Fan Login →
                                                            </button>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                        <form onSubmit={handleSubmit}>
                                            <div className="mb-3">
                                                <label className="form-label">Phone Number</label>
                                                <div className="phone-control custom-phone-input">
                                                    <PhoneInput
                                                        international
                                                        defaultCountry="ZW"
                                                        countryCallingCodeEditable={false}
                                                        placeholder="Enter phone number"
                                                        className="PhoneInput"
                                                        inputComponent="input"
                                                        name="userPhone"
                                                        value={credentials.userPhone}
                                                        onChange={handlePhoneChange}
                                                        required
                                                    />
                                                </div>
                                            </div>
                                            <div className="mb-3">
                                                <div className="form-group-flex">
                                                    <label className="form-label">Password</label>
                                                    <Link to="/forgot-password2" className="forgot-link">
                                                        Forgot password?
                                                    </Link>
                                                </div>
                                                <div className="pass-group" style={{ position: 'relative' }}>
                                                    <input
                                                        type={isPasswordVisible ? "text" : "password"}
                                                        className="form-control pass-input-sub"
                                                        name="userPassword"
                                                        value={credentials.userPassword}
                                                        onChange={handleChange}
                                                        required
                                                    />
                                                    <span
                                                        onClick={() => setIsPasswordVisible(!isPasswordVisible)}
                                                        style={{
                                                            position: 'absolute',
                                                            right: '10px',
                                                            top: '50%',
                                                            transform: 'translateY(-50%)',
                                                            cursor: 'pointer',
                                                            color: '#6c757d',
                                                            fontSize: '16px',
                                                            zIndex: 10
                                                        }}
                                                    >
                                                        {isPasswordVisible ? '🙈' : '👁️'}
                                                    </span>
                                                </div>
                                            </div>
                                            <div className="mb-3">
                                                <button
                                                    className="btn btn-primary-gradient w-100"
                                                    type="submit"
                                                    disabled={isLoading}
                                                >
                                                    {isLoading ? 'Sending OTP...' : 'Send OTP'}
                                                </button>
                                            </div>

                                            <div className="login-or">
                                                <span className="or-line" />
                                                <span className="span-or">or</span>
                                            </div>

                                            <div className="mb-3 text-center">
                                                <button
                                                    type="button"
                                                    className="btn btn-outline-primary w-100"
                                                    onClick={handleEmailLogin}
                                                >
                                                    Sign in with Email
                                                </button>
                                            </div>

                                            <div className="account-signup">
                                                <p>
                                                    Don't have an account?{" "}
                                                    <Link to="/celeb-register">Sign up</Link>
                                                </p>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default LoginCelebrity;
